/**
 * La bande du surligneur pour le thème courant, et l'encre du mot qu'elle porte.
 *
 * Lu par `<Highlight>` et par l'énoncé (`molecules/RichText`, classe `enonce-highlight`) : les
 * deux dessinent la même recette, et la question « clair ou nuit ? » ne se pose qu'ici. Sur la
 * nuit, la bande couvre le mot : il est posé sur l'aplat jaune et prend son encre ; sur fond
 * clair, il garde celle du texte qui l'entoure (`ink` vaut alors `null`).
 */
import { useIsDarkTheme } from "../../hooks/useIsDarkTheme"
import { inkOnFill, type SemanticColorKey } from "../../theme/tokens/colors"
import { highlighter, type HighlighterBand } from "../../theme/tokens/effects"

export function useHighlighterBand(): { band: HighlighterBand; ink: SemanticColorKey | null } {
    const night = useIsDarkTheme()
    return night ? { band: highlighter.night, ink: inkOnFill("accent") } : { band: highlighter.day, ink: null }
}
